import * as R from 'ramda';

export const getObjectEntries = (() => {
  if (!Object.entries) {
    Object.entries = function(obj) {
      const ownProps = R.keys(obj);
      let i = ownProps.length;
      let resArray = new Array(i);
      while (i--) resArray[i] = [ownProps[i], obj[ownProps[i]]];

      return resArray;
    };
  }
})();



// WEBPACK FOOTER //
// ./src/Common/Polyfills/index.js